/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   PageAddress.tsx
 */

import { selectIsOnlyActiveUnitOfMultiUnit, selectIsSingleUnit } from '@zcode-ui/perm-address'
import { selectDetailEntity } from '@zcode-ui/web-zumper-global-state'
import { hasHasGalleryParam } from '@zcode/nr/es/shared/bizos/rentable/selectors'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { GalleryViewDetailContainerLazyLoadableSection } from '../../components/detail/GalleryViewDetail/GalleryViewDetailContainerLazyLoadableSection'
import { PageLTRDetail } from '../PageLTRDetail'
import { PageAddressMultiUnit } from './PageAddressMultiUnit'

export const PageAddress = () => {
  const isSingleUnit = useSelector(selectIsSingleUnit)
  const isOnlyActiveUnitOfMultiUnit = useSelector(selectIsOnlyActiveUnitOfMultiUnit)
  const isBuilding = useSelector(selectDetailEntity)?.isBuilding
  const location = useLocation()
  const isGallery = hasHasGalleryParam(location.search)
  const listingIdParam = new URLSearchParams(location.search).get('listing_id')
  const isUnitOfMultiUnit = !!listingIdParam

  if (!isBuilding && (isSingleUnit || isOnlyActiveUnitOfMultiUnit || isUnitOfMultiUnit)) {
    return isGallery ? <GalleryViewDetailContainerLazyLoadableSection /> : <PageLTRDetail />
  }
  return <PageAddressMultiUnit />
}
